import { render, staticRenderFns } from "./PwaPrompt.vue?vue&type=template&id=738a65e7&scoped=true&"
import script from "./PwaPrompt.vue?vue&type=script&lang=js&"
export * from "./PwaPrompt.vue?vue&type=script&lang=js&"
import style0 from "./PwaPrompt.vue?vue&type=style&index=0&id=738a65e7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "738a65e7",
  null
  
)

export default component.exports